/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerRemoveMutationResponse, DocumentsControllerRemovePathParams, DocumentsControllerRemove401, DocumentsControllerRemove403, DocumentsControllerRemove404 } from "../../models/documentsController/DocumentsControllerRemove";

function getDocumentsControllerRemoveUrl(id: DocumentsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/documents/${id}` as const }  
  return res
}

/**
 * @summary Soft delete a document
 * {@link /api/v1/documents/:id}
 */
export async function documentsControllerRemove(id: DocumentsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentsControllerRemoveMutationResponse, ResponseErrorConfig<DocumentsControllerRemove401 | DocumentsControllerRemove403 | DocumentsControllerRemove404>, unknown>({ method : "DELETE", url : getDocumentsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}